<template>
  <div class="mx-5 mx-md-16 px-md-16">
    <v-data-table
      :headers="headers"
      :items="rows.items"
      :items-per-page="-1"
      hide-default-footer
      disable-sort
      class="elevation-1 rounded-lg"
    >
      <template v-slot:item.actions="{ item }">
        <router-link
          custom
          v-slot="{ navigate }"
          :to="{ name: 'EditTest', params: { id: item.id } }"
        >
          <v-btn icon @click="navigate"
            ><v-icon small color="orange">fa-edit</v-icon></v-btn
          >
        </router-link>
        <v-btn icon @click="deleteTest(item)"
          ><v-icon small color="red">fa-trash</v-icon></v-btn
        >
      </template>
    </v-data-table>
    <div class="pt-2 d-flex flex-column flex-md-row align-center justify-end">
      <span class="font-quicksand">Filas por páginas: </span>
      <span style="width: 50px" class="mx-md-2">
        <v-select
          v-model="itemsPerPage"
          :items="itemsPerPages"
          class="font-quicksand"
          @change="onItemsPerPageChange"
        ></v-select>
      </span>
      <span class="font-quicksand"
        >{{ rowsRangeStart }}-{{ rowsRangeEnd }} de {{ rows.totalItems }}
      </span>
      <v-pagination
        v-model="page"
        :length="rows.totalPages"
        :total-visible="pageVisible"
        color="red"
        class="font-work-sans"
        @input="onPageChange"
      ></v-pagination>
    </div>

    <dialog-test
      :test="test"
      :del="del"
      :dialog="dialog"
      @dismiss="
        () => {
          dialog = false
          loadData()
        }
      "
    />
  </div>
</template>

<script>
import DialogTest from './Dialog.vue'
import Repository from '@/repositories/RepositoryFactory'
import { createPaginationMixin } from '@/mixins/pagination'
const TestRepository = Repository.get('tests')

export default {
  components: { DialogTest },
  name: 'ActiveTests',
  props: ['search'],
  mixins: [createPaginationMixin({ debounceMs: 500 })],
  data: () => ({
    headers: [
      {
        text: 'Id',
        align: 'center',
        class:
          'primary white--text rounded-tl-lg font-weight-bold text-subtitle-2',
        value: 'id',
      },
      {
        text: 'Nombre',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'name',
      },
      {
        text: 'Precio',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'priceNew',
      },
      {
        text: 'Opciones',
        align: 'center',
        class:
          'primary white--text rounded-tr-lg font-weight-bold text-subtitle-2',
        value: 'actions',
      },
    ],
    itemsPerPages: [10, 20, 30, 50, 100],
    del: true,
    test: null,
    dialog: false,
  }),
  methods: {
    deleteTest: function (item) {
      this.test = item
      this.dialog = true
    },
    fetchPage: async function (params) {
      const res = await TestRepository.get(params)
      res.data.data.items = Array.from(
        res.data.data.items,
        ({ price, ...test }) => ({
          priceNew: `Bs. ${price}`,
          price,
          ...test,
        })
      )
      return res
    },
  },
}
</script>
